import ViewBase from "../../../../framework/core/mvvm/view_base";
import AppData from "../../../public/const/app_data";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import ModelData from "../../../public/model_data";
import roadmap from "../../../public/roadmap";

const { ccclass, property } = cc._decorator;

@ccclass
export default class RoadMapInfoView extends ViewBase {

    @property(roadmap)
    myRoadmap:roadmap = null

    @property(cc.Label)
    roadSummaryTex:cc.Label[] = []

    @property(cc.Sprite)
    lastLong:cc.Sprite[] = []

    @property(cc.Sprite)
    lastHu:cc.Sprite[] = []

    @property(SpriteFrameHolder)
    xiaSanLuSpriteHolder:SpriteFrameHolder = null

    @property(cc.Label)
    gameLimit:cc.Label = null


    start() {
    
    }

    initShow(intentData){
        let roadSumData = this.myRoadmap.getRoadListSummary(intentData)
        for(let i =0; i< this.roadSummaryTex.length; i ++){
            this.roadSummaryTex[i].string = roadSumData[i] +""
        }

        let curValue = null
        for(let i =0; i < 3; i++){
            curValue = this.myRoadmap.getForecastState(i, 1)
            if(curValue != null){
                this.lastLong[i].spriteFrame =  this.xiaSanLuSpriteHolder.getSpriteFrameByKey(i*2 + curValue) 
            }else{
                this.lastLong[i].spriteFrame = null
            }
            
            curValue = this.myRoadmap.getForecastState(i, 2)
            if(curValue != null){
                this.lastHu[i].spriteFrame =  this.xiaSanLuSpriteHolder.getSpriteFrameByKey(i*2 + curValue) 
            }else{
                this.lastHu[i].spriteFrame = null
            }
            
        }

        let rule = ModelData.instance.roomInfo.PlayRuleData
        this.gameLimit.string = rule.game_Limit
    }
}
